import React from "react";
import { Icon, PlainButton } from "@culturehq/components";
import { t, Trans } from "app/utils";

const getItemAriaLabel = (active, label) => t(`${active ? "Unselect" : "Select"} filter - ${label}`);

const ListItem = ({ active, label, onClick, value }) => (
  <li data-value={value} onClick={onClick}>
    {active && <Icon icon="checkmark" />}
    {label.label ? (
      <PlainButton aria-label={getItemAriaLabel(active, `${label.label}, ${label.legend}`)}>
        <span>
          {label.label}
          <br />
          <span className="small">
            <Trans>{label.legend}</Trans>
          </span>
        </span>
      </PlainButton>
    ) : (
      <PlainButton aria-label={getItemAriaLabel(active, label)}>{label}</PlainButton>
    )}
  </li>
);

export default ListItem;
